import { c as _c } from "react/compiler-runtime";
import GridViewIcon from '@mui/icons-material/GridView';
import { ButtonProps, Button } from './Button';
export const Dashboard: React.FC<ButtonProps> = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Button startIcon={<GridViewIcon />} text="Dashboard" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};